module.exports = __webpack_public_path__ + "img/AgradecimientoFeria_del_Trabajo_2022.b0aec4ad.png";